/**
 * /en/admin/structure/paragraphs_type/form_element_radio/fields
 */

import CLASS_NAMES from "@js/constants/css-constants.es6.js";
import { ATTRIBUTES, DOM_EVENTS, HTML_ELEMENTS } from "@js/constants/html-constants.es6.js"
import FormElementParagraph from "@js/paragraphs/form-element-paragraph.es6.js";
import LegendFormElementParagraphField
  from "@js/fields/form-element-legend-paragraph-field.es6.js";

export default class RadioFormElementParagraph extends FormElementParagraph {
  get legend() {
    return new LegendFormElementParagraphField({
      machineName: 'field_legend',
      parentElement: this,
    });
  }

  get hasValue() {
    return this.element.$().is(`:${ATTRIBUTES.CHECKED}`);
  }

  get value() {
    const $checked = this.element
      .$()
      .find(`:${ATTRIBUTES.CHECKED}`)
      .addBack(`:${ATTRIBUTES.CHECKED}`)[0];
    if ($checked) {
      return $checked.value;
    }

    return null;
  }

  constructor({ parentElement }) {
    super({
      machineName: 'form_element_radio',
      parentElement,
    });
  }

  initialize() {
    this.$().on(DOM_EVENTS.CHANGE, () => this.#formatAllOptions());
  }

  #formatAllOptions() {
    const radioGroups = this.$().find(`.${CLASS_NAMES.RADIO_GROUP}`);

    radioGroups.each((_index, element) => {
      const input = element.querySelector(HTML_ELEMENTS.INPUT);

      if (input.checked) {
        element.classList.add(CLASS_NAMES.SELECTED);
      } else {
        element.classList.remove(CLASS_NAMES.SELECTED);
      }

      if (input.disabled) {
        element.classList.add(CLASS_NAMES.DISABLED);
      } else {
        element.classList.remove(CLASS_NAMES.DISABLED);
      }
    });
  }

  toggleRequirement(required) {
    this.toggleElementRequirement(required);
    this.legend.paragraph.toggleRequirement(required);
  }

  selectOption(optionId) {
    const $element = this.element.$().filter(`[value='${optionId}']`);
    $element.attr(ATTRIBUTES.CHECKED, true);

    this.#formatAllOptions();
  }

  disableOption(optionId) {
    const $element = this.element.$().filter(`[value='${optionId}']`);
    $element.attr(ATTRIBUTES.DISABLED, true);

    this.#formatAllOptions();
  }
}

(() => {
  const radioFormElement = new RadioFormElementParagraph({});
  radioFormElement.onRendered(async () => {
    radioFormElement.initialize();
  });
})(Drupal);
